import * as constants from "../constants/authConstants";

export const loginRequest = (history) => ({
  type: constants.LOGIN_REQUEST,
  history
});

export const logout = (history) => ({
  type: constants.LOGOUT_REQUEST,
  history
});


export const authenticateUser = () => ({
  type: constants.AUTHENTICATE_USER_REQUESTED,
});